import StripeCheckoutButton from './StripeCheckoutButton';

export default StripeCheckoutButton;